export const DEPOSITO_USER = Object.freeze({
  id:50,
  name:"Josué · Depósito",
  username:"josue",
  role:"deposito",
  storeId:null,
  storeIds:Object.freeze([1, 2, 3, 4]),
});

export function operationalUsers(users = []) {
  return users.filter(user => user?.role !== "deposito");
}

export function consultantUsers(users = []) {
  return users.filter(user => user?.role === "consultant");
}

export function adminSwitcherUsers(users = [], stores = []) {
  const regularUsers = operationalUsers(users);
  return {
    adminUsers:regularUsers.filter(user => !user.storeId),
    usersByStore:stores.map(store => ({
      store,
      users:regularUsers.filter(user => Number(user.storeId) === Number(store.id)),
    })),
    depositoUsers:users.filter(user => user?.role === "deposito"),
  };
}

export function canViewAsDeposito(operator, target) {
  return target?.role !== "deposito"
    || operator?.role === "admin"
    || operator?.role === "deposito";
}